import ko from "knockout";
import moment from "moment";

export default function($app) {
	const $ui = $app.require('ui');
	const $locale = $app.require('locale');

	this.isShow = ko.observable();
	this.filterSection = ko.observable(false);
	this.filterStream = ko.observable();
	this.filterText = ko.observable('');

	this.episodeList = ko.computed(() => {
		const filterText = (this.filterText() || '').toLowerCase();
		const filterSection = (this.filterSection() ? this.filterSection().name : '').toLowerCase();

		return $app.event().episode().filter(episode => {
			if(episode.isDelay()) return false;

			if(filterSection && filterSection !== (episode.section() || '').toLowerCase()) {
				return false;
			}

			if(this.filterStream() && this.filterStream().id() !== episode.stream().id()) {
				return false;
			}

			if(filterText) {
				let filterTextFound = false;

				['name', 'info', 'section'].forEach(name => {
					const text = episode[name]();
					if(text.toLowerCase && -1 !== text.toLowerCase().indexOf(filterText)) {
						filterTextFound = true;
					}
				});

				[episode.speakers(), episode.moderators()].forEach(memberList => {
					if(memberList instanceof Array) {
						memberList.forEach(member => {
							['fullnameRu', 'fullnameEn', 'fullname', 'en_fullname', 'description', 'en_description'].forEach(key => {
								const text = String(member[key] || '');
								if(-1 !== text.toLowerCase().indexOf(filterText)) {
									filterTextFound = true;
								}
							});
						});
					}
				});

				if(!filterTextFound) {
					return false;
				}

			}

			return true;
		});
	}).extend({ throttle: 200 });

	this.episodeListByDate = ko.computed(() => {
		const date = {};
		let lastDateKey;
		const list = [];

		this.episodeList().forEach(episode => {
			const dateKey = moment.unix(episode.timeStart()).format('YYYY-MM-DD');
			lastDateKey = dateKey;
			if(!date[dateKey]) {
				date[dateKey] = {
					time: episode.timeStart,
					episode: []
				};
				list.push(date[dateKey]);
			}
			date[dateKey].episode.push(episode);
		});
		return list;
	}).extend({ throttle: 200 });

	this.sectionList = ko.computed(() => {
		const sections = [];
		const sectionsByName = {};
		$app.event().episode().forEach(episode => {
			if(episode.isDelay()) return;

			if(episode.section() && !sectionsByName[episode.section()]) {
				sections.push({
					name: episode.section(),
					color: episode.color()
				});
				sectionsByName[episode.section()] = true;
			}
		});
		return sections;
	});

	this.scrollToEpisode = id => {
		const episodeContainer = $('.episodeTable-content');
		const episode = episodeContainer.find('.episode_' + id);
		if(episode.length) {
			const offset = episodeContainer.scrollTop() + episode.position().top;
			episodeContainer.animate({scrollTop: offset});
		}
	};

	this.show = () => {
		this.isShow(true);
		return this;
	};
	this.hide = () => {
		this.isShow(false);
		return this;
	};

	this.isShow.subscribe(isShow => {
		if(isShow && $app.currentEpisode()) {
			setTimeout(() => {
				this.scrollToEpisode($app.currentEpisode().id());
			}, 500);
		}
	});

	$app.on('start', () => {
		if($app.event().stream().length > 1 && $app.event().episode().length && $app.event().moduleEpisode.showTable()) {
			this.uiButton = new $ui.Button({position: ko.observable('right'), icon: 'table', title: $locale.get('episodeTable.button.title')});
			this.uiButton.on('click', () => this.isShow(!this.isShow()));
			setTimeout(() => this.uiButton.showHint(), 5*1000);
			setTimeout(() => this.uiButton.hideHint(), 15*1000);

			$(window).on('keyup', event => {
				if(27 === event.which) {
					this.isShow(false);
				}
			});
		}
	});

	$app.on('setEpisode', () => this.isShow(false));
};
